import React, { useState } from 'react';
import { connect } from 'react-redux';

import { Loader, Paper } from 'redpoints-front-components/index';
import { NoResult } from 'redpoints-front-common/components';

import {
  getFacilitatorValidationLinkTaskRequest,
  getFacilitatorValidationLinkTaskRequestIsLoading,
} from '../../../reducers/tasks/facilitatorValidation';
import FacilitatorValidationContentActions from './FacilitatorValidationContentActions';
import FacilitatorValidationContentLinkInfo from './FacilitatorValidationContentLinkInfo';
import FacilitatorValidationContentLinks from './FacilitatorValidationContentLinks';
import NoFilterApplied from '../../../components/NoFilterApplied';
import { translate } from '../../../helpers/languageHelper';

const FacilitatorValidationContent = ({
  isLoading,
  linkInfo,
  hasFiltersApplied,
}) => {
  const [isEditing, setIsEditing] = useState(true);

  if (isLoading) {
    return (
      <div className="facilitator-validation-loader">
        <Loader isLoading />
      </div>
    );
  }

  const isLinkLoaded = linkInfo.linkId != null;

  if (!isLinkLoaded) {
    if (hasFiltersApplied) {
      return (
        <NoResult
          text={translate('common.no_more_results')}
          subtext={translate('common.enjoy')}
        />
      );
    }

    return (
      <NoFilterApplied
        title={translate('common.no_filter')}
        description={translate('common.no_filter_description')}
      />
    );
  }

  return (
    <>
      <Paper>
        <FacilitatorValidationContentLinkInfo linkInfo={linkInfo} />
        <FacilitatorValidationContentLinks
          isEditing={isEditing}
          setIsEditing={setIsEditing}
        />
      </Paper>
      <FacilitatorValidationContentActions
        linkInfo={linkInfo}
        isEditing={isEditing}
        setIsEditing={setIsEditing}
      />
    </>
  );
};

const mapStateToProps = state => ({
  isLoading: getFacilitatorValidationLinkTaskRequestIsLoading(state),
  linkInfo: getFacilitatorValidationLinkTaskRequest(state),
});

export default connect(mapStateToProps)(FacilitatorValidationContent);
